import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import { sendPostRequest } from "./../../APP/HELPERS/requests"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

function mapStateToProps(state) {
    return {
        OPEN_STATIC_MODAL: state.OPEN_STATIC_MODAL
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class StaticModal extends Component {

    /// CONSTRUCTOR ///
    constructor(props)
    {
        super(props);
        this.state = {
        };
        this.OFFSET = 0;
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.OPEN_STATIC_MODAL !== prevProps.OPEN_STATIC_MODAL) {
            if (window.innerWidth < 1200) {
                if (!this.props.OPEN_STATIC_MODAL) {
                    document.body.classList.remove("modal-open");
                    document.documentElement.scrollTop = this.OFFSET;
                } else {
                    this.OFFSET = window.pageYOffset || document.documentElement.scrollTop;
                    document.body.classList.add("modal-open");
                }
            }
        }
    }

    renderAbout = () =>
    {
        return (
            <div className="static-modal-content">

                <p className="about_text">
                    Кухня народов Северного Кавказа таит в себе множество загадок, которые уходят корнями в далекое прошлое. Бережно сохраняя традиции прошлых поколений, мы с радостью раскроем вам вкус настоящего Дагестана.
                </p>
                <p className="about_text">
                    В Дагестанской лавке вы сможете насладиться изысканными блюдами кулинарного наследия народов Cеверного Кавказа, приготовленными из натуральных продуктов халяль.
                </p>
                <p className="about_text">
                    Наши хиты - это тонкое чуду, пироги на тонком тесте: с мясом, сыром, зеленью, тыквой и картошкой с грибами. Есть ещё большие дагестанские пироги с мясом и картофелем, творогом и зеленью, сыром, курицей и грибами. В меню также говяжий бульон и разнообразные виды настоящего хинкала (лакский, даргинский, аварский, лезгинский, кумыкский). И конечно у нас есть дагестанские национальные пельмени - курзе: с мясом, творогом или зеленью. Визитная карточка нашей лавки - урбеч из семян льна и абрикосовых косточек.
                </p>

                <div className='link_holder'>
                <Link
                        className = 'link_text'
                        title="Наши лавки"
                        to="/restaurants"
                        onClick={() => this.props.openStaticModal(false)}
                    >
                        Наши лавки
                    </Link>
                    <Link
                        className = 'link_text'
                        title="Контакты"
                        to="/company/contacts"
                        onClick={() => {this.props.openStaticModal(false); this.props.toggleNav()}}
                    >
                        Контакты
                    </Link>
                </div>

                <div className="static-m-image-holder">
                    <img src="/system_images/dagestan.jpg" />
                </div>
            </div>
        );
    }

    renderDelivery = () =>
    {
        return (
            <div className="static-modal-content">

                <p><strong>Доставка осуществляется только по Москве и МО!</strong></p>
                <p>
                    <strong>График работы:</strong>
                    <br/>
                    Заказ оформить на сайте или в мобильном приложении можно круглосуточно.
                </p>
                <p>
                    <strong>Доставка:</strong>
                    <br/>
                    ПН-ВС 10:00 - 22:00
                    <br/>
                    В дальние районы принимаем заказы не позднее 20:00
                </p>
                <ul>
                    <li>Стоимость доставки - 99 руб.<br/>Стоимость услуги и минимальная сумма заказа зависят от адреса доставки</li>
                    <li>Доставляем за МКАД, условия необходимо уточнить.<br/>Проверить условия доставки можно на сайте и в мобильном приложении, для этого необходимо внести адрес доставки или уточнить у оператора назвав адрес доставки/ Оплата заказа производится на сайте и возможна наличными курьеру
</li>
                    <li>Минимальная сумма заказа от 1000р</li>
                </ul>
                <p>
                    <strong>Время доставки:</strong>
                    <br/>
                    От 60 до 180 минут в зависимости от адреса доставки.
                </p>
                <p>
                    <strong>На первый заказ через мобильное приложение действует скидка 20%, минимальная сумма заказа с учетом скидки.</strong>
                    <br/>
                    <ul>
                    <li>Скидка не распространяется на Вабабай комбо, Обед горца, Набор чуду.</li>
<li>Скидка подгружается автоматически, если соблюдены требования.</li>
</ul>
                </p>

                <p>
                    <strong>Для заказов с собой действует скидка 10%, ограничений по минимальной сумме заказа нет.</strong>
                </p>
                <p>
                    <strong>Для связи с call-центром:</strong> <a href="tel: +79689870505">+79689870505</a>
                    <br/>
                    <strong>Для связи с контролем качества:</strong> <a href="tel: +79250068648">+79250068648</a>
                </p>

                <div className="services_links">
                    <a href="https://eda.yandex.ru/moscow/r/dagestanskaya_lavka?shippingType=delivery" target="_blank">
                        <img src="/system_images/services/yandex_eda.svg" />
                    </a>
                    <a href="https://market-delivery.yandex.ru/moscow/r/dagestanskaya_lavka" target="_blank">
                        <img src="/system_images/services/market_delivery.svg" />
                    </a>
                    <a href="https://sbermarket.ru/Dagestanskajalavka?sid=48503" target="_blank">
                        <img src="/system_images/services/sbermarket.svg" />
                    </a>
                </div>

                <div className='link_holder'>
                    <Link
                        className = 'link_text'
                        title="Наши лавки"
                        to="/restaurants"
                        onClick={() => this.props.openStaticModal(false)}
                    >
                        Наши лавки
                    </Link>
                    <Link
                        className = 'link_text'
                        title="Контакты"
                        to="/company/contacts"
                        onClick={() => this.props.openStaticModal(false)}
                    >
                        Контакты
                    </Link>
                </div>

                <div className="static-m-image-holder">
                    <img src="/system_images/in_work.jpg" />
                </div>


            </div>
        );
    }

    renderUserAgreement = () =>
    {
        return (
            <div className="static-modal-content">
<h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
<ul>
<li>1.1. Настоящее Пользовательское соглашение (далее – Соглашение) относится к сайту «Дагестанская Лавка», расположенному по адресу https://daglavka.ru.</li>
<li>1.2. Сайт «Дагестанская Лавка» (далее – Сайт) является собственностью юридического лицаООО «Лаки-Китчен» (ОГРН: 5167746342055, ИНН: 7725340737, адрес регистрации: 115419 г. Москва, ул. Орджоникидзе, д.11, стр. 8, эт. 1,пом. I, ком. 18)</li>
<li>1.3. Настоящее Соглашение регулирует отношения между Администрацией сайта «Дагестанская Лавка» (далее – Администрация сайта) и Пользователем данного Сайта.</li>
<li>1.4. Администрация сайта оставляет за собой право в любое время изменять, добавлять или удалять пункты настоящего Соглашения без уведомления Пользователя.</li>
<li>1.5. Использование Сайта Пользователем означает принятие Соглашения и изменений, внесенных внастоящее Соглашение.</li>
<li>1.6. Пользователь несет персональную ответственность за проверку настоящего Соглашения на наличие изменений в нем.</li>
</ul>

<h2>2. ОПРЕДЕЛЕНИЯ ТЕРМИНОВ</h2>
<ul>
<li>2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения следующее значение:</li>
<li>2.1.1 «Дагестанская Лавка» – Интернет-ресурс, расположенный на доменном имени daglavka.com, осуществляющий свою деятельность посредством Интернет-ресурса и сопутствующих ему сервисов (далее - Сайт).</li>
<li>2.1.2. «Дагестанская Лавка» – сайт, содержащий информацию о Товарах и/или Услугах и/или Иных ценностях для пользователя, Продавце и/или Исполнителе услуг, позволяющий осуществить выбор, заказ и (или) приобретение Товара, и/или получение услуги.</li>
<li>2.1.3. Администрация сайта – уполномоченные сотрудники на управления Сайтом, действующие от имени юридического лица ООО «Лаки-Китчен».</li>
<li>2.1.4. Пользователь сайта (далее - Пользователь) – лицо, имеющее доступ к Сайту, посредством сети Интернет и использующее Сайт.</li>
<li>2.1.5. Содержание сайта (далее – Содержание) - охраняемые результаты интеллектуальной деятельности, включая тексты литературных произведений, их названия, предисловия, аннотации, статьи, иллюстрации, обложки, музыкальные произведения с текстом или без текста, графические, текстовые, фотографические, производные, составные и иные произведения, пользовательские интерфейсы, визуальные интерфейсы, названия товарных знаков, логотипы, программы для ЭВМ, базы данных, а также дизайн, структура, выбор, координация, внешний вид, общий стиль и расположение данного Содержания, входящего в состав Сайта и другие объекты интеллектуальной собственности все вместе и/или по отдельности, содержащиеся на сайте https://daglavka.com.</li>
</ul>

<h2>3. ПРЕДМЕТ СОГЛАШЕНИЯ</h2>
<ul>
<li>3.1. Предметом настоящего Соглашения является предоставление Пользователю доступа к содержащимся на Сайте Товарам и/или оказываемым услугам.</li>
<li>
    3.1.1. Сайт предоставляет Пользователю следующие виды услуг (сервисов):<br/>
    • предоставление Пользователю возможности размещения сообщений, комментариев, рецензий Пользователей, выставления оценок контенту сайта;<br/>
    • ознакомление с товарами/услугами, размещенными на Сайте;<br/>
    • выбор и заказ товаров/услуг для осуществления последующей покупки или оформления на данном Сайте.
</li>
<li>3.1.2. Под действие настоящего Соглашения подпадают все существующие (реально функционирующие) на данный момент услуги (сервисы) Сайта, а также любые их последующие модификации и появляющиеся в дальнейшем дополнительные услуги (сервисы).</li>
<li>3.2. Доступ к сайту предоставляется на бесплатной основе.</li>
<li>3.3. Настоящее Соглашение является публичной офертой. Получая доступ к Сайту Пользователь считается присоединившимся к настоящему Соглашению.</li>
<li>3.4. Использование материалов и сервисов Сайта регулируется нормами действующего законодательства Российской Федерации</li>
</ul>

<h2>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
<ul>
<li>4.1. Администрация сайта вправе:</li>
<li>4.1.1. Изменять правила пользования Сайтом, а также изменять содержание данного Сайта. Изменения вступают в силу с момента публикации новой редакции Соглашения на Сайте.</li>
<li>4.1.2. Оставляя свои персональные данные на сайте, вы даёте согласие на получение информационных рассылок о новостях, акциях и мероприятиях компании путём смс и email сообщений. Отказаться от получения рассылок можно, путём совершения звонка по номеру +79689870505.</li>
<li>4.2. Пользователь вправе:</li>
<li>4.2.1. Пользоваться всеми имеющимися на Сайте услугами, а также приобретать любые Товары и/или Услуги, предлагаемые на Сайте.</li>
<li>
4.2.2. Задавать любые вопросы, относящиеся к услугам сайта:<br/>
• по телефону: +7 968 371-05-05<br/>
• по электронной почте: info@daglavka.com<br/>
• через Форму обратной связи, расположенную по адресу: https://daglavka.com
</li>
<li>4.2.3. Пользоваться Сайтом исключительно в целях и порядке, предусмотренных Соглашением и не запрещенных законодательством Российской Федерации.</li>
<li>4.2.5. Требовать от администрации скрытия любой информации о пользователе.</li>
<li>4.2.6. Использовать информацию сайта в коммерческих целях без специального разрешения.</li>
<li>4.3. Пользователь Сайта обязуется:</li>
<li>4.3.1. Предоставлять по запросу Администрации сайта дополнительную информацию, которая имеет непосредственное отношение к предоставляемым услугам данного Сайта.</li>
<li>4.3.2. Соблюдать имущественные и неимущественные права авторов и иных правообладателей при использовании Сайта.</li>
<li>4.3.3. Не предпринимать действий, которые могут рассматриваться как нарушающие нормальную работу Сайта.</li>
<li>4.3.4. Не распространять с использованием Сайта любую конфиденциальную и охраняемую законодательством Российской Федерации информацию о физических либо юридических лицах.</li>
<li>4.3.5. Избегать любых действий, в результате которых может быть нарушена конфиденциальность охраняемой законодательством Российской Федерации информации.</li>
<li>4.3.6. Не использовать Сайт для распространения информации рекламного характера, иначе как с согласия Администрации сайта.</li>
<li>4.3.7. Не использовать сервисы с целью:</li>
<li>4.3.7.1. нарушения прав несовершеннолетних лиц и (или) причинение им вреда в любой форме.</li>
<li>4.3.7.2. ущемления прав меньшинств.</li>
<li>4.3.7.3. представления себя за другого человека или представителя организации и (или) сообщества без достаточных на то прав, в том числе за сотрудников данного сайта.</li>
<li>4.3.7.4. введения в заблуждение относительно свойств и характеристик какого-либо Товара и/или услуги, размещенных на Сайте.</li>
<li>4.3.7.5. некорректного сравнения Товара и/или Услуги, а также формирования негативного отношения к лицам, (не) пользующимся определенными Товарами и/или услугами, или осуждения таких лиц.</li>
<li>4.3.7.6. загрузки контента, который является незаконным, нарушает любые права третьих лиц; пропагандирует насилие, жестокость, ненависть и (или) дискриминацию по расовому, национальному, половому, религиозному, социальному признакам; содержит недостоверные сведения и (или) оскорбления в адрес конкретных лиц, организаций, органов власти.</li>
<li>4.3.7.7. побуждения к совершению противоправных действий, а также содействия лицам, действия которых направлены на нарушение ограничений и запретов, действующих на территории Российской Федерации.</li>
<li>4.3.8. Обеспечить достоверность предоставляемой информации</li>
<li>4.3.9. Обеспечивать сохранность личных данных от доступа третьих лиц.</li>
<li>4.4. Пользователю запрещается:</li>
<li>4.4.1. Использовать любые устройства, программы, процедуры, алгоритмы и методы, автоматические устройства или эквивалентные ручные процессы для доступа, приобретения, копирования или отслеживания содержания Сайта.</li>
<li>4.4.2. Нарушать надлежащее функционирование Сайта.</li>
<li>4.4.3. Любым способом обходить навигационную структуру Сайта для получения или попытки получения любой информации, документов или материалов любыми средствами, которые специально не представлены сервисами данного Сайта.</li>
<li>4.4.4. Несанкционированный доступ к функциям Сайта, любым другим системам или сетям, относящимся к данному Сайту, а также к любым услугам, предлагаемым на Сайте.</li>
<li>4.4.4. Нарушать систему безопасности или аутентификации на Сайте или в любой сети, относящейся к Сайту.</li>
<li>4.4.5. Выполнять обратный поиск, отслеживать или пытаться отслеживать любую информацию о любом другом Пользователе Сайта.</li>
<li>4.4.6. Использовать Сайт и его Содержание в любых целях, запрещенных законодательством Российской Федерации, а также подстрекать к любой незаконной деятельности или другой деятельности, нарушающей права Сайта или других лиц.</li>
</ul>

<h2>5. ИСПОЛЬЗОВАНИЕ САЙТА</h2>
<ul>
<li>5.1. Сайт и Содержание, входящее в состав Сайта, принадлежит и управляется Администрацией сайта.</li>
<li>5.2. Содержание Сайта защищено авторским правом, законодательством о товарных знаках, а также другими правами, связанными с интеллектуальной собственностью, и законодательством о недобросовестной конкуренции.</li>
<li>5.3. Настоящее Соглашение распространяет свое действия на все дополнительные положения и условия о покупке Товара и/или оказанию услуг, предоставляемых на Сайте.</li>
<li>5.4. Информация, размещаемая на Сайте не должна истолковываться как изменение настоящего Соглашения.</li>
<li>5.5. Администрация сайта имеет право в любое время без уведомления Пользователя вносить изменения в перечень Товаров и услуг, предлагаемых на Сайте, и (или) их цен.</li>
<li>5.6. Документ указанный в пункте 5.7. настоящего Соглашения регулирует в соответствующей части и распространяют свое действие на использование Пользователем Сайта.</li>
<li>5.7. Политика конфиденциальности. </li>
<li>5.8. Любой из документов, перечисленных в пункте 5.7 настоящего Соглашения может подлежать обновлению. Изменения вступают в силу с момента их опубликования на Сайте.</li>
</ul>

<h2>6. ОТВЕТСТВЕННОСТЬ</h2>
<ul>
<li>6.1. Любые убытки, которые Пользователь может понести в случае умышленного или неосторожного нарушения любого положения настоящего Соглашения, а также вследствие несанкционированного доступа к коммуникациям другого Пользователя, Администрацией сайта не возмещаются.</li>
<li>6.2. Администрация сайта не несет ответственности за:</li>
<li>6.2.1. Задержки или сбои в процессе совершения операции, возникшие вследствие непреодолимой силы, а также любого случая неполадок в телекоммуникационных, компьютерных, электрических и иных смежных системах.</li>
<li>6.2.2. Действия систем переводов, банков, платежных систем и за задержки связанные с их работой.</li>
<li>6.2.3. Надлежащее функционирование Сайта, в случае, если Пользователь не имеет необходимых технических средств для его использования, а также не несет никаких обязательств по обеспечению пользователей такими средствами.</li>
</ul>

<h2>7. НАРУШЕНИЕ УСЛОВИЙ ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ</h2>
<ul>
<li>7.1. Администрация сайта имеет право раскрыть информацию о Пользователе, если действующее законодательство Российской Федерации требует или разрешает такое раскрытие.</li>
<li>7.2. Администрация сайта вправе без предварительного уведомления Пользователя прекратить и (или) заблокировать доступ к Сайту, если Пользователь нарушил настоящее Соглашение или содержащиеся в иных документах условия пользования Сайтом, а также в случае прекращения действия Сайта либо по причине технической неполадки или проблемы.</li>
<li>7.3. Администрация сайта не несет ответственности перед Пользователем или третьими лицами за прекращение доступа к Сайту в случае нарушения Пользователем любого положения настоящего Соглашения или иного документа, содержащего условия пользования Сайтом.</li>
</ul>

<h2>8. РАЗРЕШЕНИЕ СПОРОВ</h2>
<ul>
<li>8.1. В случае возникновения любых разногласий или споров между Сторонами настоящего Соглашения обязательным условием до обращения в суд является предъявление претензии (письменного предложения о добровольном урегулировании спора).</li>
<li>8.2. Получатель претензии в течение 30 календарных дней со дня ее получения, письменно уведомляет заявителя претензии о результатах рассмотрения претензии.</li>
<li>8.3. При невозможности разрешить спор в добровольном порядке любая из Сторон вправе обратиться в суд за защитой своих прав, которые предоставлены им действующим законодательством Российской Федерации.</li>
<li>8.4. Любой иск в отношении условий использования Сайта должен быть предъявлен в течение 5 дней после возникновения оснований для иска, за исключением защиты авторских прав на охраняемые в соответствии с законодательством материалы Сайта. При нарушении условий данного пункта любой иск оставляется судом без рассмотрения.</li>
</ul>

<h2>9. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h2>
<ul>
<li>9.1. Администрация сайта не принимает встречные предложения от Пользователя относительно изменений настоящего Пользовательского соглашения.</li>
<li>9.2. Отзывы Пользователя, размещенные на Сайте, не являются конфиденциальной информацией и могут быть использованы Администрацией сайта без ограничений.</li>
</ul>
            </div>
        );
    }

    renderPolicy = () =>
    {
        return (
            <div className="static-modal-content">
                <p>
                    Оставляя данные на сайте, Вы соглашаетесь с Политикой конфиденциальности и защиты информации.
                </p>
                <h2>Защита данных</h2>
                <p>
                    Администрация сайта daglavka.com (далее Сайт) не может передать или раскрыть информацию, предоставленную пользователем (далее Пользователь) при регистрации и использовании функций сайта третьим лицам, кроме случаев, описанных законодательством страны, на территории которой пользователь ведет свою деятельность.
                </p>
                <h2>Получение персональной информации</h2>
                <p>
                    Для коммуникации на сайте пользователь обязан внести некоторую персональную информацию. Для проверки предоставленных данных, сайт оставляет за собой право потребовать доказательства идентичности в онлайн или офлайн режимах.
                </p>
                <h2>Использование персональной информации</h2>
                <p>
                    Сайт использует личную информацию Пользователя для обслуживания и для улучшения качества предоставляемых услуг. Оставляя свои персональные данные на сайте, вы даёте согласие на получение информационных рассылок о новостях, акциях и мероприятиях компании путём смс и email сообщений. Отказаться от получения рассылок можно, путём совершения звонка по номеру +79689870505. Часть персональной информации может быть предоставлена банку или платежной системе, в случае, если предоставление этой информации обусловлено процедурой перевода средств платежной системе, услугами которой Пользователь желает воспользоваться. Сайт прилагает все усилия для сбережения в сохранности личных данных Пользователя. Личная информация может быть раскрыта в случаях, описанных законодательством, либо когда администрация сочтет подобные действия необходимыми для соблюдения юридической процедуры, судебного распоряжения или легального процесса необходимого для работы Пользователя с Сайтом. В других случаях, ни при каких условиях, информация, которую Пользователь передает Сайту, не будет раскрыта третьим лицам.
                </p>
                <h2>Коммуникация</h2>
                <p>
                    После того, как Пользователь оставил данные, он получает сообщение, подтверждающее его успешную регистрацию. Пользователь имеет право в любой момент прекратить получение информационных бюллетеней воспользовавшись соответствующим сервисом в Сайте.
                </p>
                <h2>Ссылки</h2>
                <p>
                    На сайте могут содержаться ссылки на другие сайты. Сайт не несет ответственности за содержание, качество и политику безопасности этих сайтов. Данное заявление о конфиденциальности относится только к информации, размещенной непосредственно на сайте.
                </p>
                <h2>Безопасность</h2>
                <p>
                    Сайт обеспечивает безопасность учетной записи Пользователя от несанкционированного доступа.
                </p>
                <h2>Уведомления об изменениях</h2>
                <p>
                    Сайт оставляет за собой право вносить изменения в Политику конфиденциальности без дополнительных уведомлений. Нововведения вступают в силу с момента их опубликования. Пользователи могут отслеживать изменения в Политике конфиденциальности самостоятельно.
                </p>
            </div>
        );
    }

    renderPayment = () =>
    {
        return (
            <div className="static-modal-content">
                <h4>Клиент может оплатить заказ двумя способами:</h4>
                <p><strong>1.</strong> Наличными курьеру (сумма согласно накладной). Оплата осуществляется курьеру по кассовому чеку.</p>
                <p><strong>2.</strong> Безналичная оплата on-line.<br/>Для этого нужно после оформления заказа указать данные своей банковской карты и произвести оплату.</p>
                <p>Оплатить выбранные через Сервис товары можно наличными курьеру, осуществившему доставку, или же с использованием электронной платежной системы на Сервисе. Во втором случае Сервис предоставляет интерфейс платежной системы, не участвуя в проведении оплаты.</p>
                <p>Сервис также предоставляет возможность оплаты выбранных товаров онлайн с использованием электронной платежной системы ПАО "Сбербанк". В этом случае согласно договору между ПАО "Сбербанк" и ООО "Лаки-Китчен", платёж осуществляет платежная система ПАО "Сбербанк" по реквизитам ООО "Лаки-Китчен", который в установленный срок производит реализацию товаров. ООО "Лаки-Китчен" не участвует в проведении оплаты.</p>
                <p>При оплате заказа банковской картой, обработка платежа (включая ввод номера карты) происходит на защищенной странице процессинговой системы, которая прошла международную сертификацию. Это значит, что Ваши конфиденциальные данные (реквизиты карты, регистрационные данные и др.) не поступают в ООО "Лаки-Китчен", их обработка полностью защищена и никто, в том числе наш интернет-магазин, не может получить персональные и банковские данные клиента.</p>
                <p>При работе с карточными данными применяется стандарт защиты информации, разработанный международными платёжными системами Visa и Mastercard - Payment Card Industry Data Security Standard (PCI DSS), что обеспечивает безопасную обработку реквизитов банковской карты Держателя. Применяемая технология передачи данных гарантирует безопасность по сделкам с Банковскими картами путем использования протоколов Transport Layer Security (TLS), Verified by Visa, Secure Code, и закрытых банковских сетей, имеющих высшую степень защиты. В случае оформления возврата, денежные средства возвращаются на ту же карту, с которой производилась оплата.</p>
                <div className="static-m-image-holder">
                    <img src="/system_images/payments_icos.png" class="payments_logo" />
                </div>
            </div>
        );
    }

    renderContent = () =>
    {
        switch (this.props.OPEN_STATIC_MODAL) {
            case 'ABOUT':
                return this.renderAbout();
            case 'PAYMENT':
                return this.renderPayment();
            case 'DELIVERY':
                return this.renderDelivery();
            case 'POLICY':
                return this.renderPolicy();
            case 'AGREEMENT':
                return this.renderUserAgreement();
        }
    }

    renderTitle = () =>
    {
        switch (this.props.OPEN_STATIC_MODAL) {
            case 'ABOUT':
                return 'О нас';
            case 'PAYMENT':
                return 'Оплата';
            case 'DELIVERY':
                return 'Доставка';
            case 'POLICY':
                return 'Политика конфидецниальности';
            case 'AGREEMENT':
                return 'Пользовательское соглашение';
        }
    }

	render()
    {
        if (this.props.OPEN_STATIC_MODAL) {
            return (
                <div>
                    <div className="modal-overlay" onClick={() => this.props.openStaticModal(false)}>
                    </div>
                    <div className="modal-box static-m-modal">
                        <div className="modal_top">
                            <a className="close-modal" onClick={() => this.props.openStaticModal(false)}>
                                <img src="/system_images/close.png" />
                            </a>
                            <h4>{this.renderTitle()}</h4>
                        </div>
                        <div className="modal_content">
                            {this.renderContent()}
                        </div>
                    </div>
                </div>
            );
        } else {
            return false;
        }
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(StaticModal);